export enum FilterSpecialValues {
  ALL = "ALL",
  NOT_ASSIGNED = "NONE",
  EMPTY = "",
  ONLY_BOOKED = "ONLY_BOOKED",
  PRESENT = "PRESENT",
  ME = "ME",
}
